// Port of api/fuel/app/classes/filter/search/games/sorts/query/rating/group/average.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.group',
	post: false,
	require: function(config, filter) { return sorted('rating.group', filter) > 0 && config.ownerType !== F.OWNER_USER },
	run: function(config, filter, data, query) {
		query.order('AVG(r.rating_value)', sortReverse('rating.group', filter), sortPriority('rating.group', filter))
	}
}
